module.exports = __webpack_public_path__ + "img/face10.e3a405b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/faces/face10.jpg
// module id = vFrx
// module chunks = 0